import "./IconGlobe.scss";

export const IconGlobe = () => {
  return <span className="icon-globe"></span>;
};
